import { Component, Input, OnInit } from '@angular/core';
import { CdkMenuModule } from '@angular/cdk/menu';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { ActionButton } from '../../../00_modules/contextbar/services/action-buttons/models/action-button.model';
import { TranslateModule } from '@ngx-translate/core';
import { switchMap, takeUntil } from 'rxjs/operators';
import { from, Subject } from 'rxjs';
import { AppContextFactory } from '../../../00_modules/contextbar/services/app-context/app-context.factory';
import { ActionButtonGroupResolver } from '../../../00_modules/contextbar/services/action-buttons/resolver/action-button-group.resolver';
import { OrderingFacade } from '../../../store/facade/ordering.facade';
import { OrderState } from '../../../domain/ordering/models/OrderState';
import { UiFacade } from '../../../store/facade/ui.facade';
import { IconComponent } from '../../../00_modules/shared/components/fa-icon/fa-icon.component';

@Component({
    selector: 'je-split-button',
    imports: [CdkMenuModule, TranslateModule, IconComponent],
    templateUrl: './split-button.component.html',
})
export class SplitButtonComponent implements OnInit {
    @Input()
    level: string;
    public firstGroupButton: ActionButton;
    public firstGroupOtherButton: ActionButton[];
    public secondGroupButton: ActionButton;
    public secondGroupOtherButton: ActionButton[];
    public areSecondaryButtonsDisabled = false;
    readonly menuPositions: ConnectedPosition[] = [
        { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top' },
        { originX: 'end', originY: 'top', overlayX: 'end', overlayY: 'bottom' },
    ];
    private destroy$: Subject<boolean> = new Subject<boolean>();
    public appContext$ = this.appContextFactory.context$.pipe(takeUntil(this.destroy$));

    constructor(
        private appContextFactory: AppContextFactory,
        private buttonGroupResolver: ActionButtonGroupResolver,
        private orderingFacade: OrderingFacade,
        private uiFacade: UiFacade,
    ) {}

    ngOnInit(): void {
        this.orderingFacade.order$.subscribe(order => {
            this.updateButtons(order.state);
        });

        this.uiFacade.isDirty$.subscribe(isDirty => {
            this.areSecondaryButtonsDisabled = isDirty;
        });
    }

    private updateButtons(state: OrderState) {
        this.appContext$.pipe(switchMap(context => from(this.buttonGroupResolver.getActionButtons(context, state)))).subscribe(buttons => {
            this.firstGroupButton = null;
            this.firstGroupOtherButton = null;
            this.secondGroupButton = null;
            this.secondGroupOtherButton = null;

            if (buttons?.firstGroup?.length > 0) {
                this.firstGroupButton = buttons.firstGroup[0];
                this.firstGroupOtherButton = buttons.firstGroup.splice(1);
            }

            if (buttons?.secondGroup?.length > 0) {
                this.secondGroupButton = buttons.secondGroup[0];
                this.secondGroupOtherButton = buttons.secondGroup.splice(1);
            }
        });
    }
}
